import { createFeatureSelector } from '../../create-feature-selector';
import { createSelector } from 'reselect';
import { ProjectConfigurationsKeyNames } from '../types';

const featureRootSelector = createFeatureSelector('configurations');

export const getLaminate = createSelector(featureRootSelector, (v) => v.laminate);

export const getLaminateConfiguration = createSelector(getLaminate, (v) => v.configuration ?? []);

export const getLaminateConfigurationArea = createSelector(getLaminateConfiguration, (conf) => {
  const area = conf.find(({ key }) => key === ProjectConfigurationsKeyNames.area)?.value;
  return area ? Number(area) : undefined;
});

export const getLaminateConfigurationLoading = createSelector(getLaminate, (v) => v.loading);
